export default "/checkout";
